import { render, staticRenderFns } from "./resourceApplication.vue?vue&type=template&id=6f0e6504&scoped=true&"
import script from "./resourceApplication.vue?vue&type=script&lang=js&"
export * from "./resourceApplication.vue?vue&type=script&lang=js&"
import style0 from "./resourceApplication.vue?vue&type=style&index=0&id=6f0e6504&lang=scss&scoped=true&"
import style1 from "./resourceApplication.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e6504",
  null
  
)

export default component.exports